import { Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { API_URL } from "constants/ApiUrl";
import { useEffect, useState } from "react";
import { FaUserCircle } from "react-icons/fa";

const Header = ({ player }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const role = localStorage.getItem("role");
  const [playerPhoto, setPlayerPhoto] = useState(null);
  useEffect(() => {
    setPlayerPhoto(null);
    if (player?.photo) {
      const cleanApiUrl = API_URL.replace(/\/+$/, '');
      let cleanPhoto = player?.photo.replace(/^\/+/, '');
      cleanPhoto = player?.photo.split('/').pop();
      if (!cleanPhoto.includes('uploads/')) {
        cleanPhoto = 'uploads/' + cleanPhoto;
      }

      setPlayerPhoto(`${cleanApiUrl}/${cleanPhoto}`);
    }
  }, [player?.photo])
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          paddingRight: "10px",
        }}
      >
        <Button
          style={{
            backgroundColor: "#FFFFFF",
            color: "#157088",
            borderColor: "#157088",
            borderRadius: "5px",
            cursor: "pointer",
            font: "Poppins",
          }}
          onClick={() => {
            navigate("/annonces");
          }}
        >
          {t("playerInfo.postAd")}
        </Button>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
          width: "100%",
          backgroundColor: "#F3F8F9",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px", // Espacement entre la photo et les infos
            padding: "20px",
          }}
        >
          {/* Image */}
          {
            playerPhoto ?
              <img
                src={playerPhoto}
                alt="Player"
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                }}
              />
              :
              <FaUserCircle size={72} className="text-secondary" style={{ marginRight: "15px" }} />
          }
          {/* Informations */}
          <div>
            <h5 style={{ margin: 0, color: "#000000", font: "Visby CF" }}>
              {player?.firstName} {player?.lastName}
            </h5>
            <div style={{ margin: "5px 0", color: "#000000", opacity: "50%" }}>
              {player?.age && `${player?.age} ans`}
            </div>
            {role === "agent" &&
              <Button
                size="sm"
                style={{
                  backgroundColor: "#157088",
                  opacity: "70%",
                  color: "#FFFFFF",
                }}
              >
                {t("playerInfo.contactPlayer")}
              </Button>
            }
          </div>
        </div>
      </div>
    </>
  );
};
export default Header;
